import React from 'react';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import { MdOutlineWork as WorkIcon } from 'react-icons/md';
import { IoSchool as SchoolIcon } from 'react-icons/io5';
import { FaStar as StarIcon } from 'react-icons/fa';
import './WorkExperience.css';
import { timelineData } from '../data/portfolioData';


const WorkExperience: React.FC = () => {
  const timeLineData = timelineData;

  return (
    <>
      <div className="timeline-container">
        <h2 className="timeline-title">Work Experience & Education</h2>
      </div>
      <VerticalTimeline>
        {timeLineData.map((item, index) => (
          <VerticalTimelineElement
            key={index}
            className={`vertical-timeline-element--${item.timelineType}`}
            contentStyle={{
              background: item.timelineType === 'education' ? '#2a1a1a' : '#1a1a1a',
              color: '#fff',
              borderTop: item.timelineType === 'education' ? '3px solid #e50914' : index === 0 ? '3px solid #e50914' : '3px solid #333',
              borderRadius: '8px',
              boxShadow: item.timelineType === 'education' ? '0 4px 14px rgba(229, 9, 20, 0.25)' : '0 4px 14px rgba(0, 0, 0, 0.5)',
            }}
            contentArrowStyle={{ borderRight: item.timelineType === 'education' ? '7px solid #2a1a1a' : '7px solid #1a1a1a' }}
            date={item.dateRange}
            iconStyle={
              item.timelineType === 'education'
                ? { background: '#e50914', color: '#fff' }
                : index === 0
                  ? { background: '#e50914', color: '#fff' }
                  : { background: '#333', color: '#fff' }
            }
            icon={item.timelineType === "work" ? <WorkIcon /> : <SchoolIcon />}
          >
            {item.timelineType === "work" ? (
              <div style={{ color: '#fff' }}>
                <h3 className="vertical-timeline-element-title" style={{ fontSize: '1.2rem', fontWeight: 700 }}>{item.title}</h3>
                <h4 className="vertical-timeline-element-subtitle" style={{ color: '#e50914', marginTop: '4px' }}>{item.name}</h4>
                <p style={{ color: '#ccc', fontSize: '0.9rem', lineHeight: 1.6 }}>{item.summaryPoints}</p>
              </div>
            ) : (
              <div style={{ color: '#fff' }}>
                <h3 className="vertical-timeline-element-title" style={{ fontSize: '1.2rem', fontWeight: 700 }}>{item.name}</h3>
                <h4 className="vertical-timeline-element-subtitle" style={{ color: '#e50914', marginTop: '4px' }}>{item.title}</h4>
                <p style={{ color: '#ccc', fontSize: '0.9rem', lineHeight: 1.6 }}>{item.summaryPoints}</p>
              </div>
            )}
          </VerticalTimelineElement>
        ))}
        <VerticalTimelineElement
          iconStyle={{ background: 'rgb(16, 204, 82)', color: '#fff' }}
          icon={<StarIcon />}
        />
      </VerticalTimeline>
    </>
  );
};

export default WorkExperience;
